import classNames from 'classnames';
import './style.scss';

const SectionTitle = ({ title, outline }) => {
    return title ? (
        <div className={classNames('section-title', outline && 'outline')}>
            <span className="section-title__line"></span>
            <h2 className="section-title__text">{title}</h2>
            <span className="section-title__line"></span>
        </div>
    ) : <></>
};

export default SectionTitle;
